const localData = require('@localData/index.json');
export const categories = localData?.categories;
